import { Component, HostListener, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateFilterComponent } from '../../../../../_shared/components';
import { ChartData, StackedBarChartComponent } from '../../../../_shared';
import { DateIntervalFilterData } from '../../../../../_shared/models';
import { DateInterval } from '../../../../../_shared/enums';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-frequency-volume-big-modal',
  imports: [StackedBarChartComponent, DateFilterComponent, TranslocoDirective],
  standalone: true,
  templateUrl: './frequency-volume-big-modal.component.html',
  styleUrl: './frequency-volume-big-modal.component.scss'
})
export class FrequencyVolumeBigModal {
  // Mock headline figures until the API supplies this summary.
  protected readonly headline = { value: '200ℓ', change: '+19.29%' };
  protected buttonMenuClick(event: MouseEvent): void {
    event.stopPropagation();
  }
  protected fillUpFrequencyBigData = ChartData.fillUpFrequencyBigData;
  protected chartMargin = { top: 5, right: 1, bottom: 35, left: 33, height: 293 };
  protected viewMode = signal<'all' | 'fillUp' | 'totalVolume' | 'avgVolume'>('all');
  protected fillUpFrequencyData = ChartData.fillUpFrequency;
  private readonly modalRef = inject(NgbActiveModal);

  public utilizationDateFilter: DateIntervalFilterData;
  public defaultInterval: DateInterval = DateInterval.Day;

  constructor() {
    this.utilizationDateFilter = {} as DateIntervalFilterData;
  }

  onUtilizationDateFilterChange(filter: DateIntervalFilterData): void {
    this.utilizationDateFilter = filter;
  }

  protected closeModal(): void {
    this.modalRef.close();
  }
}
